var map = {
	"./base/AngryGorilla.png": "38ac",
	"./base/BRPDBolici.png": "d9f7",
	"./base/BanWick.png": "67c2",
	"./base/Banonus.png": "3880",
	"./base/Banos.png": "372f",
	"./base/BanoshisBlessing.png": "5297",
	"./base/Benis.png": "ff5f",
	"./base/BigSpook.png": "da79",
	"./base/BoomerInvestor.png": "abe3",
	"./base/Caesar.png": "03f8",
	"./base/CamoBan.png": "d802",
	"./base/CocoBlocker.png": "f927",
	"./base/CorruptBolici.png": "3c2e",
	"./base/DecentTipper.png": "9bfc",
	"./base/EA.png": "9ac4",
	"./base/FatCocoBlocker.png": "552a",
	"./base/HealthyMilkshake.png": "ad96",
	"./base/HippieInvestor.png": "e171",
	"./base/ImpatientChimp.png": "b4cf",
	"./base/JungleWoodWall.png": "bb42",
	"./base/Ketamine.png": "9b27",
	"./base/LimitSeller.png": "f32c",
	"./base/LoanShark.png": "3dab",
	"./base/MelonsMusk.png": "8b86",
	"./base/ModerateTipper.png": "59e2",
	"./base/PeelHeadMonkey.png": "079f",
	"./base/PointyBanana.png": "fc16",
	"./base/PrivateKeyBruteforce.png": "0715",
	"./base/Serenifty.png": "b169",
	"./base/ShitcoinCEO.png": "05a5",
	"./base/SocialMediaInfluencer.png": "122c",
	"./base/TheTwins.png": "2516",
	"./base/Twin.png": "4b63",
	"./base/brain.png": "2bca",
	"./cardBack.png": "5e8c",
	"./creatureLoadingTemplate.png": "b692c",
	"./nft/WelcometothemonKeyverse.png": "2773",
	"./nft/monKeyprinterBRRrain.png": "bb89",
	"./nft/spooKeyBadge2021.png": "82fb",
	"./spellLoadingTemplate.png": "3888"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f8e9";